// Google Analytics 4 loader — consent-gated, production-only (skips preview/localhost
// so dev traffic never pollutes the real oxo-hub.com data). ID from env.
const GA_ID = process.env.REACT_APP_GA_ID;
let _loaded = false;

export function analyticsEnabled() {
  if (!GA_ID) return false;
  const h = window.location.hostname;
  if (h === "localhost" || h === "127.0.0.1" || h.endsWith(".preview.emergentagent.com")) return false;
  return true;
}

export function hasAnalyticsConsent() {
  try {
    const p = JSON.parse(localStorage.getItem("oxo_cookie_consent") || "{}");
    return !!p.analytics;
  } catch {
    return false;
  }
}

export function loadGA() {
  if (_loaded || !analyticsEnabled() || !hasAnalyticsConsent()) return;
  _loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  // page views are sent explicitly (SPA) via trackPageView
  gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
}

export function trackPageView(path) {
  if (!_loaded || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// Fire a GA4 conversion/custom event (no-op if GA not loaded / consent not given).
export function trackEvent(name, params = {}) {
  if (!_loaded || !window.gtag) return;
  window.gtag("event", name, params);
}
